var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8674 19.1144C20.4648 18.9942 20.8191 18.3681 20.5216 17.8363C19.7929 16.5336 18.6231 15.389 17.1175 14.5211C15.2191 13.4266 12.893 12.8334 10.5 12.8334C8.1071 12.8334 5.78102 13.4266 3.88257 14.521C2.37704 15.3889 1.20716 16.5336 0.478513 17.8363C0.181035 18.3681 0.535333 18.9942 1.13272 19.1144L2.60626 19.411C7.81652 20.4599 13.1836 20.4599 18.3938 19.411L19.8674 19.1144Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5392 5.83335C16.5392 9.05501 13.8354 11.6667 10.5001 11.6667C7.16475 11.6667 4.46095 9.05501 4.46095 5.83335C4.46095 2.61168 7.16475 0 10.5001 0C13.8354 0 16.5392 2.61168 16.5392 5.83335Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.26c807b713d0867c9efb4cfcb9dd46c6.svg";
export { ForwardRef as ReactComponent };